import DogCuteEmpty from "@/assets/images/dog-cute-no-data.png"
import { Box, Stack, Typography } from "@mui/material"
import { FC, ReactNode } from "react"
import Image from "next/image"

import * as styles from "./styles"

type EmptyRelendTableProps = {
  title?: string
  content: string
  buttonCTA?: ReactNode
}

const EmptyRelendTable: FC<EmptyRelendTableProps> = ({ title, content, buttonCTA }) => {
  return (
    <Box data-testid='empty-relend-table'>
      {title && <Typography sx={styles.title}>{title}</Typography>}
      <Stack alignContent='center' alignItems='center' gap={2} className='py-4'>
        <Image src={DogCuteEmpty} alt='empty-icon' width={118} height={118} />
        <Typography className='text-neutral-600'>{content}</Typography>
        {buttonCTA && <>{buttonCTA}</>}
      </Stack>
    </Box>
  )
}

export default EmptyRelendTable
